import React, { FC } from "react";

export interface SectionWhoWeAreProps {
  className?: string;
  img: string;
}

const SectionWhoWeAre: FC<SectionWhoWeAreProps> = ({
  className = "",
  img,
}) => {
  return (
    <div
      className={`nc-SectionWhoWeAre relative ${className}`}
      data-nc-id="SectionWhoWeAre"
    >
      <div className="flex flex-col items-center relative text-center">
        <div className="w-full max-w-4xl space-y-5 lg:space-y-7 mb-10">
          <h2 className="text-3xl !leading-tight font-semibold text-neutral-900 md:text-4xl xl:text-5xl dark:text-neutral-100">
            Who We Are
          </h2>
          <div className="text-base xl:text-lg text-neutral-6000 dark:text-neutral-400 space-y-4">
            <p>
              We're your car's new best friend—on wheels! At Schoon, we bring high-quality, eco-friendly car wash and detailing services right to where you are—parking garages, office buildings, apartments, you name it. We know life gets busy, and finding time for a car wash is the last thing on your to-do list. That's why we come to you!
            </p>
            <p>
              Our team of detail-obsessed pros makes it easy to keep your car looking fresh without wasting water or sitting in line at a traditional car wash. We're all about convenience, quality, and helping the planet while we're at it.
            </p>
            <p>
              Think of us as the modern way to care for your car—zero hassle, zero guilt, and a whole lot of shine!
            </p>
          </div>
        </div>
        <div className="w-full max-w-3xl">
          <img className="w-full" src={img} alt="Schoon Car Wash Service" />
        </div>
      </div>
    </div>
  );
};

export default SectionWhoWeAre;
